export default __webpack_public_path__ + "static/media/UniversityTonic.6a2cc03680d29f1e22df75b13eafc0e0.webp";